import type { FilterOptions } from "@/utils/content";
import type { FilterState } from "@/types/content";

interface FilterPanelProps {
  options: FilterOptions;
  value: FilterState;
  onChange: (next: FilterState) => void;
  onReset: () => void;
}

interface GroupProps {
  title: string;
  items: string[];
  active: string;
  onSelect: (value: string) => void;
}

function FilterGroup({ title, items, active, onSelect }: GroupProps) {
  return (
    <div>
      <h3 className="text-xs font-semibold text-foreground-500 tracking-wide mb-2.5">{title}</h3>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={() => onSelect("")}
          className={`chip cursor-pointer transition-colors ${
            active === ""
              ? "bg-primary-500 text-background-50"
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
        >
          全部
        </button>
        {items.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => onSelect(item)}
            className={`chip cursor-pointer transition-colors ${
              active === item
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {item}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ options, value, onChange, onReset }: FilterPanelProps) {
  const activeCount = [value.type, value.region, value.year, value.tag].filter(Boolean).length;

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-sm text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500" aria-hidden="true"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          className="text-xs text-foreground-500 hover:text-accent-600 cursor-pointer transition-colors whitespace-nowrap"
        >
          重置{activeCount > 0 ? `（${activeCount}）` : ""}
        </button>
      </div>

      <div className="space-y-5">
        <FilterGroup
          title="类型"
          items={options.types}
          active={value.type}
          onSelect={(next) => onChange({ ...value, type: next })}
        />
        <div className="h-px bg-background-200"></div>
        <FilterGroup
          title="地区"
          items={options.regions}
          active={value.region}
          onSelect={(next) => onChange({ ...value, region: next })}
        />
        <div className="h-px bg-background-200"></div>
        <FilterGroup
          title="年份"
          items={options.years}
          active={value.year}
          onSelect={(next) => onChange({ ...value, year: next })}
        />
        <div className="h-px bg-background-200"></div>
        <FilterGroup
          title="标签"
          items={options.tags}
          active={value.tag}
          onSelect={(next) => onChange({ ...value, tag: next })}
        />
      </div>
    </div>
  );
}